import { render, staticRenderFns } from "./jiyang_add.vue?vue&type=template&id=28fada8a&scoped=true&"
import script from "./jiyang_add.vue?vue&type=script&lang=js&"
export * from "./jiyang_add.vue?vue&type=script&lang=js&"
import style0 from "./jiyang_add.vue?vue&type=style&index=0&id=28fada8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fada8a",
  null
  
)

export default component.exports